import { render, staticRenderFns } from "./BuildingSocietyIncorporationApplications.vue?vue&type=template&id=4705c54a&scoped=true&"
import script from "./BuildingSocietyIncorporationApplications.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyIncorporationApplications.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyIncorporationApplications.vue?vue&type=style&index=0&id=4705c54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705c54a",
  null
  
)

export default component.exports